__webpack_require__.p = "/app-new-version-notification/referrals/";